/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import emailCheckStyle from "./emailCheckStyle";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DialogModal from "../DialogModal/DialogModal";
import { useLocation, useNavigate } from "react-router-dom";
import ValidatorTextField, { ValidatorTextFieldProps } from "../FormFields/ValidatorTextField";
import { useForm } from "../../provider/Form/FormProvider";
import LoginAction from "../Login/LoginAction";

type EmailCheckProps = {
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  redirectProps?: Object | null;
} & ValidatorTextFieldProps;

export default function EmailCheck({ label, name, emailErrorText, setEmailErrorText, redirectProps = null, ...rest }: EmailCheckProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleChange, errors, values } = useForm();
  const openLogin = () => {
    let locationState: { loginModalOpen: string; email: string; from?: Object } = {
      loginModalOpen: "emailCheck",
      email: values.email ?? "",
    };
    if (redirectProps) {
      locationState.from = redirectProps;
    }
    navigate(location.pathname, { state: locationState });
  };

  const closeLogin = () => {
    navigate(-1);
  };

  const isError = !!errors[name] || emailErrorText !== "";
  const errorText = emailErrorText || (
    <Grid component={"span"} container alignItems={"center"}>
      <Grid component={"span"} sx={emailCheckStyle.emailHelperText}>
        Bereits ein Konto?
      </Grid>
      <Button component={"span"} variant={"text"} color={"primary"} onClick={() => openLogin()}>
        Jetzt anmelden
      </Button>
    </Grid>
  );
  return (
    <>
      <ValidatorTextField
        label={label}
        name={name}
        error={isError}
        helperText={isError && errorText ? errorText : ""}
        onChange={(e) => {
          setEmailErrorText("");
          handleChange(e);
        }}
        {...rest}
      />
      <DialogModal open={!!(location.state && location.state.loginModalOpen === "emailCheck")} onClose={closeLogin} title="Anmelden">
        <LoginAction showPostfix={false} />
      </DialogModal>
    </>
  );
}
